import { gql } from '@apollo/client';

export const FILTERED_SOURCE_OF_INCOME = gql`
  query filteredSourceOfIncome($input: FilterSourceOfIncome!) {
    filteredSourceOfIncome(input: $input) {
      id
      name
    }
  }
`;
